import React from 'react';

// ** MUI
import { type SxProps, type Theme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import mergeSxProps from '../shared/mergeSxProps';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';

type Props = {
  className?: string;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';
  size?: number | string;
  sx?: SxProps<Theme>;
  fullHeight?: boolean;
  width?: number | string;
  message?: string;
};

const Spinner = ({
  className,
  color = 'secondary',
  size,
  sx,
  fullHeight,
  width,
  message,
}: Props) => {
  const widthAndHeight = width
    ? { width, height: width }
    : fullHeight
      ? { width: '100%', height: '100%' }
      : null;
  return (
    <Box
      className={clsx('spinner', className)}
      sx={mergeSxProps(
        {
          display: width ? 'inline-flex' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: width ? 0 : 8,
          flexDirection: 'column',
        },
        widthAndHeight,
        sx,
      )}
    >
      <CircularProgress color={color} size={width || size || 40} />
      {message && (
        <Typography variant="body2" sx={{ mt: 4 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default Spinner;
